window.wlAssessmentConfig = {
  successRedirectUrl: '/pages/select-product',
  programmeRedirectUrl: '/products/the-lotus-programme',
  logoAlt: 'Lotus',
  api: {
    url: 'https://demo-app-config.looprx.io/api/create-assessment',
    imagesUrl: 'https://demo-app-config.looprx.io/api/upload-assessment-images-v3',
    mediaTypeDefinitionsUrl:
      'https://demo-app-config.looprx.io/api/media-type-definitions/tenant',
    nhsUrl: 'https://demo-app-config.looprx.io/api/nhs-organisations',
    tenant: 'lotus_healths-KGHFAGDH',
    formType: 'lotus_healths',
    authCookie: 'access_token',
    uploadcarePubkey: 'c73768e131ec40847fe1',
    videoUploadcarePubkey: 'c73768e131ec40847fe1',
    categoryId: 1
  },
  phases: [
    {
      id: 'intro',
      type: 'intro',
      headingLine1: 'Your weight loss',
      headingLine2: 'journey starts here',
      consentBefore:
        'Please confirm that you are completing this consultation for yourself and that you will answer honestly and accurately. You agree to share any medical conditions, past operations, and any medicines you are currently taking. You understand that only one weight loss medication should be used at a time, that you have read and agree to our',
      links: [
        { label: 'Terms & Conditions', url: '/pages/terms-conditions' },
        { label: 'Privacy-Policy', url: '/pages/privacy-policy' },
        { label: 'Patient Consent Form', url: '/pages/patient-consent-form' }
      ],
      consentAfter: 'and that providing accurate information is essential for your safety.',
      agreeLabel: 'I Agree',
      buttonLabel: 'Start my consultation'
    },
    {
      id: 'assessment-1',
      phase: 'assessment',
      type: 'page',
      questions: [
        {
          id: 'reasons',
          type: 'multiselect',
          heading: 'What is your main reason for wanting to lose weight or maintain a healthy weight?',
          hint: 'Select all that apply',
          otherValue: 'other',
          otherPlaceholder: 'Type your answer here...',
          options: [
            { label: 'To improve my overall health', value: 'overall-health' },
            { label: 'To reduce the risk of future health problems', value: 'reduce-risk' },
            { label: 'To improve my heart and cardiovascular health', value: 'heart-health' },
            {
              label:
                'To improve a weight-related condition (e.g., high blood pressure, prediabetes, PCOS)',
              value: 'weight-related-condition'
            },
            { label: 'To feel more confident', value: 'confidence' },
            { label: 'To increase my energy levels', value: 'energy' },
            { label: 'To improve fitness or mobility', value: 'fitness' },
            { label: 'To support my mental wellbeing', value: 'mental' },
            { label: "To maintain the progress I've already made", value: 'maintain' },
            { label: 'Other (Pleases Specify)', value: 'other' }
          ]
        },
        {
          id: 'user_type',
          type: 'single',
          heading: 'Please select the option that best describes you:',
          options: [
            {
              label: 'I will be starting prescription weight-loss medication for the first time',
              value: 'first-time'
            },
            {
              label:
                'I am currently using, or have previously used, prescription weight-loss medication and would like to switch to Lotus',
              value: 'switching'
            },
            {
              label:
                "I'm not taking prescription weight-loss medication, but I'd like to join The Lotus Programme for guidance, support, and access to the Community.",
              value: 'programme-only',
              skipMedical: true,
              confirmTitle: "Great — you're all set to join The Lotus Programme.",
              confirmBody: 'You can skip the medical questions and go straight to select your programme.',
              confirmButton: 'Next'
            }
          ]
        },
        {
          id: 'weight_goal',
          type: 'single',
          heading: 'What is your current goal regarding your weight?',
          showIf: { field: 'user_type', equals: 'switching' },
          options: [
            { label: 'I would like to start losing weight', value: 'start-losing' },
            {
              label: 'I am already losing weight and would like to continue',
              value: 'continue-losing'
            },
            { label: 'I would like to maintain my current weight', value: 'maintain' }
          ]
        }
      ],
      nextLabel: 'Next'
    },
    {
      id: 'assessment-2',
      phase: 'assessment',
      type: 'page',
      noticeWhen: { field: 'user_type', equals: 'first-time' },
      notice:
        'As this is your first time starting weight loss medication, you will only be able to order the recommended starter dose for safety and clinical reasons.',
      questions: [
        {
          id: 'age_eligible',
          type: 'single',
          heading: 'Are you aged between 18 and 74?',
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ],
          rejectValue: 'no',
          rejectMessage:
            'Unfortunately, we are unable to safely prescribe for you as you do not meet our age criteria. Please contact your GP for further help.'
        },
        {
          id: 'height_weight',
          type: 'height-weight',
          heading: 'What is your current Weight and Height?',
          hint: "This helps us calculate your BMI and check if you're eligible for treatment safely and accurately.",
          bmiMin: 20,
          bmiOkMin: 30,
          bmiMidMin: 27,
          bmiSuccess:
            'Great news — your BMI meets the criteria for treatment. You can continue with the consultation.',
          bmiFail:
            'Your BMI is currently below the safe range for this treatment. For your safety, we recommend discussing your options with your GP.',
          bmiSwitchLow:
            "You're only eligible for treatment with us if you're switching from another provider and have used prescription weight-loss medication within the last 6 months. We'll check this with you in the next steps.",
          bmiSwitchMid:
            "You're only eligible for treatment with us if you're switching from another provider and have used prescription weight-loss medication within the last 6 months, or if you have a weight-related health condition, or are from an Asian, Black, Middle Eastern, or mixed ethnic background. We'll check this with you in the next steps."
        },
        {
          id: 'goal_weight',
          type: 'goal-weight',
          heading: 'What is your goal weight?'
        },
        {
          id: 'ethnicity',
          type: 'single',
          heading: 'Please choose the option that best describes you:',
          hint: 'Healthy BMI ranges are different according to your ethnic background.',
          otherValue: 'other',
          otherPlaceholder: 'Type your answer here...',
          options: [
            { label: 'Asian or Asian British', value: 'asian' },
            { label: 'Black (Caribbean, African)', value: 'black' },
            { label: 'Mixed ethnicities', value: 'mixed' },
            { label: 'White', value: 'white' },
            { label: 'Other ethnic group', value: 'other' }
          ]
        }
      ],
      showBack: true,
      nextLabel: 'Next'
    },
    {
      id: 'assessment-3',
      phase: 'assessment',
      type: 'page',
      questions: [
        {
          id: 'weight_conditions',
          type: 'multiselect',
          heading: 'Have you been diagnosed with any health conditions that are often linked to weight?',
          exclusiveValue: 'none',
          options: [
            { label: 'Prediabetes', value: 'prediabetes' },
            { label: 'Type 2 diabetes', value: 't2d' },
            { label: 'High blood pressure', value: 'hypertension' },
            {
              label: 'Heart or blood vessel disease (including a previous heart attack)',
              value: 'heart-disease'
            },
            { label: 'Previous stroke', value: 'stroke' },
            { label: 'Obstructive sleep apnoea', value: 'osa' },
            { label: 'Acid reflux/GERD (and taking medication)', value: 'gerd' },
            { label: 'Fatty liver disease (MASLD/NAFLD)', value: 'fatty-liver' },
            { label: 'Osteoarthritis', value: 'osteoarthritis' },
            { label: 'Polycystic ovary syndrome (PCOS)', value: 'pcos' },
            { label: 'Depression (and taking regular medication)', value: 'depression' },
            { label: 'Erectile dysfunction', value: 'ed' },
            { label: 'Menopause/ Peri-menopause', value: 'menopause' },
            { label: 'None of the above', value: 'none' }
          ]
        },
        {
          id: 'allergies',
          type: 'single',
          heading:
            'Do you have any allergies to any of the following medicines, or to any other medicines or substances?',
          hint: 'This helps us ensure the treatment we offer is safe for you.',
          otherValue: 'other',
          otherPlaceholder: 'Type your answer here...',
          otherHint:
            'Please list any other allergies you have. This includes allergies to medications (including over-the-counter or herbal), foods, ingredients or substances.',
          rejectValues: ['semaglutide', 'tirzepatide', 'liraglutide', 'orforglipron'],
          rejectMessage:
            'We are unable to supply this product to you. Please contact your GP for further help.',
          options: [
            { label: 'Wegovy / Ozempic (semaglutide)', value: 'semaglutide' },
            { label: 'Mounjaro (tirzepatide)', value: 'tirzepatide' },
            { label: 'Saxenda / Nevolat / Victoza (liraglutide)', value: 'liraglutide' },
            { label: 'Foundayo (orforglipron)', value: 'orforglipron' },
            { label: 'I have other allergies', value: 'other' },
            { label: 'None of the above', value: 'none' }
          ]
        },
        {
          id: 'diabetes_meds',
          type: 'single',
          heading:
            'If you have type 2 diabetes, do you take medications other than metformin to control your blood sugar?',
          hint: 'e.g. insulin, gliclazide, sitagliptin, dapagliflozin',
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
            { label: "I don't have type 2 diabetes", value: 'no-t2d' }
          ]
        }
      ],
      showBack: true,
      nextLabel: 'Next'
    },
    {
      id: 'assessment-4',
      phase: 'assessment',
      type: 'page',
      questions: [
        {
          id: 'unsafe_conditions',
          type: 'single',
          heading: 'Have you been diagnosed with or had surgery for any of the following?',
          hint: "These conditions can make weight-loss medications unsafe, so it's important we check before continuing.",
          detailList: [
            {
              label: 'Gallbladder issues',
              detail:
                'surgery/ removal within the last 1 year, gallstones that have not been removed, infection, bile duct/flow issues'
            },
            { label: 'Pancreatitis' },
            { label: 'Hypoglycaemia', detail: 'low blood sugar' },
            { label: 'Liver Cirrhosis or Transplant' },
            { label: 'Severe Chronic Kidney Disease (CKD)' },
            { label: 'An Eating Disorder e.g. anorexia or bulimia' },
            {
              label: 'Any cognitive or memory condition',
              detail: 'such as dementia that may affect your ability to make informed decisions.'
            },
            {
              label: 'Severe gastrointestinal disease',
              detail:
                "e.g. inflammatory bowel disease, ulcerative colitis, Crohn's disease or gastroparesis (delayed stomach emptying)"
            },
            { label: 'Chronic Malabsorption Syndrome', detail: 'celiac disease' },
            {
              label: 'Weight-loss surgery or a gastric procedure in the past 12 months',
              detail:
                'Includes gastric band (placement or removal), sleeve gastrectomy, gastric bypass, gastric balloon, endoscopic sleeve gastroplasty, or biliopancreatic diversion.'
            },
            {
              label: 'An endocrine (hormone-related) condition',
              detail:
                "e.g. an overactive thyroid awaiting radioactive iodine or surgery, acromegaly, Addison's disease, Cushing's syndrome, congenital adrenal hyperplasia, or a growth hormone disorder."
            },
            { label: 'Major surgery in the last 3 months' },
            {
              label:
                'A personal or family history of Medullary Thyroid Cancer (MTC), Thyroid cancer, or Multiple Endocrine Neoplasia 2 (MEN2) syndrome'
            },
            { label: 'Any cancer diagnosis currently being managed by a specialist' }
          ],
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ],
          rejectValue: 'yes',
          rejectMessage:
            'We are unable to supply this product to you. Please contact your GP for further help.'
        },
        {
          id: 'other_conditions',
          type: 'single',
          heading: 'Do you have any other medical conditions?',
          hint: "These conditions can make weight-loss medications unsafe, so it's important we check before continuing.",
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ]
        },
        {
          id: 'other_conditions_detail',
          type: 'text',
          heading: 'Please list any other medical conditions you have.',
          hint: 'Sharing this information helps our clinicians make sure your treatment plan is safe and appropriate.',
          placeholder: 'Type your answer here...',
          showIf: { field: 'other_conditions', equals: 'yes' }
        },
        {
          id: 'rx_medications',
          type: 'single',
          heading: 'Are you taking any of the following prescription medications?',
          bullets: [
            'Antiretrovirals',
            'Amiodarone',
            'Carbamazepine',
            'Ciclosporin',
            'Clozapine',
            'Digoxin',
            'Fenfluramine',
            'Insulin',
            'Lithium',
            'Oral Antifungals',
            'Oral Bisphosphonates',
            'Oral Methotrexate',
            'Phenobarbital',
            'Phenytoin',
            'Primidone',
            'Somatrogon',
            'Tacrolimus',
            'Theophylline',
            'Warfarin'
          ],
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ],
          rejectValue: 'yes',
          rejectMessage:
            'We are unable to supply this product to you. Please contact your GP for further help.'
        },
        {
          id: 'thyroid_steroids',
          type: 'single',
          heading: 'Do you take any medications to treat your cholesterol, thyroid or any steroid medications?',
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ],
          infoWhen: 'yes',
          infoMessage:
            'When you lose weight, or change how you eat- this can affect how well these medications work. Therefore, your GP may need to keep a closer eye on this, including your thyroid levels. Keep taking these medications as you normally would while using weight loss injections. However, by continuing with this form you agree to contact your GP to review these medications once you have started any new weight loss medication and periodically throughout treatment.'
        }
      ],
      showBack: true,
      nextLabel: 'Next'
    },
    {
      id: 'assessment-5',
      phase: 'assessment',
      type: 'page',
      questions: [
        {
          id: 'sex',
          type: 'single',
          heading: 'What sex were you assigned at birth?',
          options: [
            { label: 'Male', value: 'male' },
            { label: 'Female', value: 'female' }
          ]
        },
        {
          id: 'pregnancy',
          type: 'single',
          heading: 'Are you pregnant, breastfeeding, or trying for a baby?',
          showIf: { field: 'sex', equals: 'female' },
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ],
          rejectValue: 'yes',
          rejectMessage:
            'Weight loss medication is not suitable during pregnancy, breastfeeding, or when trying for a baby.'
        }
      ],
      showBack: true,
      nextLabel: 'Next'
    },
    {
      id: 'assessment-5b',
      phase: 'assessment',
      type: 'page',
      questions: [
        {
          id: 'med_history',
          type: 'single',
          heading: 'What is the most recent medication you have used to help you lose weight?',
          otherValue: 'other',
          otherPlaceholder: 'Type your answer here...',
          options: [
            { label: 'Wegovy Injection (Semaglutide)', value: 'wegovy-injection' },
            { label: 'Wegovy Tablet (Semaglutide)', value: 'wegovy-tablet' },
            { label: 'Ozempic (semaglutide)', value: 'ozempic' },
            { label: 'Mounjaro (tirzepatide)', value: 'mounjaro' },
            { label: 'Saxenda / Nevolat (liraglutide)', value: 'saxenda' },
            { label: 'Victoza (liraglutide)', value: 'victoza' },
            { label: 'Foundayo (Tablet)', value: 'foundayo-tablet' },
            {
              label: 'Other prescription weight-loss medication (please specify)',
              value: 'other'
            },
            {
              label: 'I have never taken any prescription medication for weight loss',
              value: 'never'
            }
          ]
        },
        {
          id: 'last_used',
          type: 'single',
          heading: 'When did you last use {med}?',
          showIf: {
            field: 'med_history',
            in: [
              'wegovy-injection',
              'wegovy-tablet',
              'ozempic',
              'mounjaro',
              'saxenda',
              'victoza',
              'foundayo-tablet'
            ]
          },
          options: [
            { label: 'Within the last 4 weeks', value: 'within-4-weeks' },
            { label: 'Between 4–8 weeks ago', value: '4-8-weeks' },
            { label: 'More than 8 weeks ago', value: 'more-than-8-weeks' }
          ]
        },
        {
          id: 'last_dose',
          type: 'single',
          heading: 'What was the last dose of {med} you were taking?',
          showIf: {
            field: 'med_history',
            in: [
              'wegovy-injection',
              'wegovy-tablet',
              'ozempic',
              'mounjaro',
              'saxenda',
              'victoza',
              'foundayo-tablet'
            ]
          },
          dosesByMed: {
            'wegovy-injection': ['0.25mg', '0.5mg', '1.0mg', '1.7mg', '2.4mg', '7.2mg'],
            'wegovy-tablet': ['1.5mg', '4.0mg', '9.0mg', '25.0mg'],
            ozempic: ['0.25mg', '.5mg', '1.0mg', '2.0mg'],
            mounjaro: ['2.5mg', '5.0mg', '7.5mg', '10.0mg', '12.5mg', '15.0mg'],
            saxenda: ['0.6mg', '1.2mg', '1.8mg', '2.4mg', '3.0mg'],
            victoza: ['0.6mg', '1.2mg', '1.8mg', '2.4mg', '3.0mg'],
            'foundayo-tablet': ['0.8mg', '2.5mg', '5.5mg', '9mg', '14.5mg', '17.2mg']
          }
        },
        {
          id: 'first_med_date',
          type: 'date-ymd',
          heading: 'When did you first start using {med}?',
          hint: 'Please enter the day, month and year. An approximate date is fine if you are not sure.',
          showIf: {
            field: 'med_history',
            in: [
              'wegovy-injection',
              'wegovy-tablet',
              'ozempic',
              'mounjaro',
              'saxenda',
              'victoza',
              'foundayo-tablet',
              'other'
            ]
          }
        },
        {
          id: 'weight_1_month_ago',
          type: 'weight-simple',
          heading: 'What was your weight approximately 1 month ago?',
          showIf: {
            field: 'med_history',
            in: [
              'wegovy-injection',
              'wegovy-tablet',
              'ozempic',
              'mounjaro',
              'saxenda',
              'victoza',
              'foundayo-tablet',
              'other'
            ]
          }
        },
        {
          id: 'starting_med_weight',
          type: 'weight-simple',
          heading: 'What was your weight when you first started {med}?',
          showIf: {
            field: 'med_history',
            in: [
              'wegovy-injection',
              'wegovy-tablet',
              'ozempic',
              'mounjaro',
              'saxenda',
              'victoza',
              'foundayo-tablet',
              'other'
            ]
          }
        },
        {
          id: 'side_effects_while_taking',
          type: 'single',
          heading: 'Did you experience any side effects while taking {med}?',
          showIf: {
            field: 'med_history',
            in: [
              'wegovy-injection',
              'wegovy-tablet',
              'ozempic',
              'mounjaro',
              'saxenda',
              'victoza',
              'foundayo-tablet',
              'other'
            ]
          },
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ]
        },
        {
          id: 'switch_stop_reason',
          type: 'single',
          heading:
            'If you have stopped this medication or would like to switch to another one, please tell us why',
          showIf: {
            field: 'med_history',
            in: [
              'wegovy-injection',
              'wegovy-tablet',
              'ozempic',
              'mounjaro',
              'saxenda',
              'victoza',
              'foundayo-tablet',
              'other'
            ]
          },
          otherValue: 'other',
          otherPlaceholder: 'Type your answer here...',
          options: [
            { label: "I didn't lose as much weight as I expected", value: 'not-enough-loss' },
            { label: 'I experienced side effects', value: 'side-effects' },
            { label: 'The medication became too expensive', value: 'expensive' },
            { label: 'I found the injections difficult', value: 'injections-difficult' },
            { label: 'I had trouble accessing the medication', value: 'access-trouble' },
            { label: 'My previous provider stopped supplying it', value: 'provider-stopped' },
            { label: "My dose wasn't increased as expected", value: 'dose-not-increased' },
            { label: 'I prefer to try a different medication', value: 'prefer-different' },
            { label: 'Other (please specify)', value: 'other' },
            {
              label: 'Not applicable (I am continuing with the same medication)',
              value: 'not-applicable'
            }
          ]
        }
      ],
      showBack: true,
      nextLabel: 'Next'
    },
    {
      id: 'assessment-switch',
      phase: 'assessment',
      type: 'page',
      questions: [
        {
          id: 'switching_provider',
          type: 'single',
          heading: "If you're switching to Lotus from another provider, please tell us:",
          hint: 'Which provider were you using previously?',
          otherValue: 'other',
          otherPlaceholder: 'Type your answer here...',
          options: [
            { label: 'Boots', value: 'boots' },
            { label: 'Superdrug', value: 'superdrug' },
            { label: 'MedExpress', value: 'medexpress' },
            { label: 'Numan', value: 'numan' },
            { label: 'Voy', value: 'voy' },
            { label: 'Pharmacy2U', value: 'pharmacy2u' },
            { label: 'Juniper', value: 'juniper' },
            { label: 'Asda', value: 'asda' },
            { label: 'Morrisons', value: 'morrisons' },
            { label: 'Shemed', value: 'shemed' },
            { label: 'Zava', value: 'zava' },
            { label: 'Oushk', value: 'oushk' },
            { label: 'I am not switching from another provider', value: 'not-switching' },
            { label: 'Other (please specify)', value: 'other' }
          ]
        },
        {
          id: 'lotus_choose_reasons',
          type: 'multiselect',
          heading: 'What is your main reason for choosing Lotus?',
          hint: 'Select all that apply.',
          showIf: {
            field: 'switching_provider',
            in: [
              'boots',
              'superdrug',
              'medexpress',
              'numan',
              'voy',
              'pharmacy2u',
              'juniper',
              'asda',
              'morrisons',
              'shemed',
              'zava',
              'oushk',
              'other'
            ]
          },
          otherValue: 'other',
          otherPlaceholder: 'Type your answer here...',
          options: [
            {
              label: 'I was recommended to Lotus by a friend or family member',
              value: 'recommended'
            },
            {
              label: 'I wanted access to The Lotus Programme & the app',
              value: 'programme-app'
            },
            { label: 'Cost with my previous provider', value: 'cost' },
            { label: 'Slow approval times for prescriptions', value: 'slow-approval' },
            { label: 'Delivery issues with my previous provider', value: 'delivery' },
            { label: 'Poor customer service by my previous provider', value: 'service' },
            {
              label: "I didn't feel clinically supported by my previous provider",
              value: 'clinical-support'
            },
            { label: 'Other (please specify)', value: 'other' }
          ]
        },
        {
          id: 'additional_info',
          type: 'single',
          heading:
            'Do you have any questions or is there anything you feel is important for us to know before we prescribe your medication?',
          otherValue: 'yes',
          otherPlaceholder: 'Type your answer here...',
          options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
          ]
        }
      ],
      showBack: true,
      nextLabel: 'Continue',
      nextPhaseId: 'image-upload'
    },
    {
      id: 'image-upload',
      phase: 'image-upload',
      type: 'image-upload',
      showBack: true,
      buttonLabel: 'Choose Treatment'
    },
    {
      id: 'details',
      phase: 'details',
      type: 'gp-details',
      showBack: true,
      buttonLabel: 'Choose Treatment'
    }
  ]
};
